
import { Component, Vue } from 'vue-property-decorator'
import keyCodeMapperCharacter from '@/utils/keycodemap.utils'
import * as onScan from 'onscan.js'
import StockMappingProvider from '@/resources/stock-mapping.provider'

@Component({
  components: {}
})
export default class StockMappingProduct extends Vue {
  stockMappingService = new StockMappingProvider()

  code = ''

  loadingProduct = false

  page = 1

  totalPages = 0

  totalItems = 0

  items: any = []

  isFirstFetch = true

  mounted (): void {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const _this = this
    onScan.attachTo(document, {
      suffixKeyCodes: [13],
      reactToPaste: true,
      onScan (sCode) {
        const patternUrl = /^(https:\/\/www\.gentlewomanonline\.com\/|https:\/\/gentlewomanonline\.com\/|https:\/\/www\.matter-makers\.com\/|https:\/\/matter-makers\.com\/)/
        const scanned = sCode.trim()
        if (patternUrl.test(scanned.toLowerCase())) {
          const splitCodeFromUrl = scanned.split('/')
          const code = splitCodeFromUrl[splitCodeFromUrl.length - 1]
          if (code) _this.searchCode(code)
        } else {
          _this.$buefy.toast.open({ message: 'กรุณาสแกน QR Code ของสินค้า', type: 'is-danger' })
        }
      },
      keyCodeMapper (oEvent: any) {
        if (keyCodeMapperCharacter[+oEvent.keyCode] !== undefined) {
          return keyCodeMapperCharacter[+oEvent.keyCode][+oEvent.shiftKey]
        }
        return onScan.decodeKeyEvent(oEvent)
      }
    })
  }

  onScroll (): void {
    if (this.loadingProduct) return
    if (this.page >= this.totalPages) return

    const el = this.$refs.scrollWrapper as HTMLElement
    if (!el) return

    const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 120

    if (nearBottom) {
      this.page++
      this.fetchPaginate()
    }
  }

  // แยกการ์ดตาม sku และ store เพราะ code เดียวกันอาจอยู่หลาย store
  get groupedSkus (): Array<any> {
    const map: any = {}

    this.items.forEach((item: any) => {
      const storeId = item.store?.id ?? ''
      const key = `${storeId}::${item.code}`

      if (!map[key]) {
        map[key] = {
          key,
          name: item.product?.name ?? item.name ?? '',
          code: item.code ?? '',
          colorSize: `${item.sku?.color?.name?.toUpperCase() ?? ''} - ${item.sku?.size?.name?.toUpperCase() ?? ''}`,
          image: item.product?.photoUrls?.[0] ?? '',
          storeName: item.store?.name ?? '',
          totalQty: 0,
          locations: []
        }
      }

      map[key].totalQty += item.qty ?? 0
      map[key].locations.push({
        id: item.id,
        name: item.location?.name ?? '-',
        qty: item.qty ?? 0
      })
    })

    return Object.values(map)
  }

  searchCode (code: string): void {
    this.code = code
    this.isFirstFetch = true
    this.fetchPaginate(true)
  }

  async fetchPaginate (isClear = false): Promise<any> {
    if (isClear) {
      this.page = 1
      this.totalPages = 0
      this.totalItems = 0
      this.items = []
    }

    // สแกนสินค้าใหม่ระหว่างโหลด: ทิ้งผลของสินค้าเก่า
    const { code } = this
    try {
      this.loadingProduct = true
      const { data } = await this.stockMappingService.getMappingAllStores({
        search: code,
        page: this.page,
        limit: 20
      })
      if (this.code !== code) return
      if (data.results?.length) {
        this.items = [
          ...this.items,
          ...data.results
        ]
      }
      this.totalPages = data.pages
      this.totalItems = data.total
    } catch (error: any) {
      this.$store.dispatch('Components/setSnackbar', {
        value: true,
        message: error?.message || error,
        type: 'error'
      })
    } finally {
      if (this.code === code) {
        this.loadingProduct = false
        this.isFirstFetch = false
      }
    }
  }

  // eslint-disable-next-line class-methods-use-this
  beforeDestroy (): void {
    onScan.detachFrom(document)
  }
}
